import React from 'react';
import { FormattedMessage } from 'react-intl';

export default {
    trackingLabel: 'Download on the App Store',
    icon: 'appStore',
    href: 'https://itunes.apple.com/us/app/1stdibs/id938157117?mt=8',
    dataTn: 'footer-download',
    formattedMessage: (
        <FormattedMessage
            id="dbl.Footer.app_link_download"
            defaultMessage="Download on the App Store"
        />
    ),
};
